import * as React from "react";
import { forwardRef } from "react";
const SvgShortLeftArrow = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 8, viewBox: "0 0 12 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M3.22033 3.33333L5.60699 0.94L4.66699 0L0.666992 4L4.66699 8L5.60699 7.06L3.22033 4.66667H11.3337V3.33333H3.22033Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgShortLeftArrow);
export { ForwardRef as ReactComponent };
